import Head from 'next/head';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import Saved from '@cont/Saved/Saved';
import { useSelectorToStore } from '@hooks/reduxHooks';
import { fetchTopologyInfo } from '@actions/topologies';
import { fetchSavedCount } from '@actions/saved';
import { useSetSelectedNav } from '@stores/sidenav';
import { SAVED_PAGE } from '@constants/segment';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/index';
import { emptyObject } from '@constants/empty';
import escape from '@utils/escapeHTML';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const SavedPage = ({ goalUID }) => {
  const goalInfo = useSelectorToStore(
    ({ topologies }) => topologies.topologyDetails[goalUID]
  );
  const { goalSlug, title, uid } = goalInfo || emptyObject;
  const goalTitle = 'My Saved Lists';
  const goalDescription = `Prepare live from Top Educators with comprehensive, structured, and crash courses along with practice section for ${title} on Unacademy Plus.`;
  const canonicalURL = `https://unacademy.com/goal/${goalSlug}/${uid}/saved`;
  const imageURL =
    'https://static.uacdn.net/static/dist/c76c2e18c7980818a913f9467c74c567.png';

  useSetSelectedNav('saved');

  return (
    <>
      <NextSeo
        title={goalTitle}
        description={goalDescription}
        openGraph={{
          title: goalTitle,
          description: goalDescription,
          images: [
            {
              url: imageURL
            }
          ],
          url: canonicalURL
        }}
      />
      <Head>
        <title>{goalTitle}</title>
      </Head>
      <Saved />
    </>
  );
};

SavedPage.pageInfo = {
  isMWebSupported: true,
  name: SAVED_PAGE,
  layoutOptions: {
    showPlusNav: true
  }
};

export default SavedPage;

SavedPage.getInitialProps = setupInitialProps(
  async ({ store, query, isServer }) => {
    const { goalUID } = query;
    const promises = [];

    if (!store.getState().topologies?.topologyDetails?.[goalUID])
      promises.push(store.dispatch(fetchTopologyInfo(goalUID)));

    promises.push(store.dispatch(fetchSavedCount(goalUID)));
    if (promises.length) await Promise.all(promises);
    return {
      isServer,
      goalUID: escape(goalUID)
    };
  },
  SavedPage.pageInfo
);

SavedPage.propTypes = {
  goalUID: PropTypes.string.isRequired
};
SavedPage.Layout = Layout;
SavedPage.Wrapper = PageReduxProvider;
